// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".seo-block[data-v-91673fda]{max-width:300px}.seo-image[data-v-91673fda]{margin:0 auto 1rem}.seo-image path[data-v-91673fda]{fill:#481d72;stroke:#481d72}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
